<div class="auth-container">
  <!-- Left Panel - Hero Section with Tower Images -->
  <div class="auth-hero-panel">
    <!-- Image Slideshow -->
    <div class="auth-slideshow" #slideshow>
      <div class="auth-slide active auth-slide-1"></div>
      <div class="auth-slide auth-slide-2"></div>
      <div class="auth-slide auth-slide-3"></div>
    </div>

    @if (redirectAppName(); as appName) {
      <div class="auth-redirect-banner" role="status">
        <div class="auth-redirect-banner-title">
          You&rsquo;ve been redirected to the Vertical Bridge Portal
        </div>
        <p class="auth-redirect-banner-body">
          We&rsquo;ve updated how you access {{ appName }}. The Vertical Bridge Portal is now the centralized entry point for {{ appName }} and other VB applications.
        </p>
        <div class="auth-redirect-banner-meaning">What this means for you:</div>
        <ul class="auth-redirect-banner-list">
          <li>Use this page as your new starting point to access {{ appName }}.</li>
          <li>Please bookmark this page for future access.</li>
          <li>If you save credentials in your browser, we recommend saving them for this URL.</li>
        </ul>
        <p class="auth-redirect-banner-reassure">Your access and existing workflows remain the same.</p>
      </div>
    }

    <!-- Hero Content Overlay -->
    <div class="auth-hero-content">
      <div class="auth-hero-logo">
        <img src="VerticalBridge_Logo3_wht.svg" alt="Vertical Bridge" />
      </div>

      <div class="auth-hero-welcome">Welcome to</div>

      <h1 class="auth-hero-tagline">
        The Vertical Bridge <span>Portal</span>
      </h1>

      <p class="auth-hero-description">
        A secured portal providing centralized access to your Vertical Bridge platforms.
      </p>
    </div>

    <!-- Slide Indicators -->
    <div class="auth-slide-indicators">
      <div class="auth-indicator active" data-slide="0"></div>
      <div class="auth-indicator" data-slide="1"></div>
      <div class="auth-indicator" data-slide="2"></div>
    </div>
  </div>

  <!-- Right Panel - Form Content -->
  <div class="auth-form-panel">
    <ng-content />
  </div>
</div>
